import * as Swiper from 'swiper/dist/js/swiper.min';

namespace PFF.controllers.home {

	function initBrandMomenetsSlider(){

	}

	export function init() {
		initBrandMomenetsSlider();
	}
}

PFF.controllers.home.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/home.ts